import { render, staticRenderFns } from "./ViewSwitch.vue?vue&type=template&id=4d21cad1&scoped=true"
import script from "./ViewSwitch.vue?vue&type=script&lang=js"
export * from "./ViewSwitch.vue?vue&type=script&lang=js"
import style0 from "./ViewSwitch.vue?vue&type=style&index=0&id=4d21cad1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21cad1",
  null
  
)

export default component.exports